import { render } from "./EnvironmentGame.vue?vue&type=template&id=7d08ddfc&scoped=true"
import script from "./EnvironmentGame.vue?vue&type=script&lang=js"
export * from "./EnvironmentGame.vue?vue&type=script&lang=js"

import "./EnvironmentGame.vue?vue&type=style&index=0&id=7d08ddfc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d08ddfc"]])

export default __exports__